import { useEffect, useState } from 'react';
import markImg from './assets/measurments/mark-m.svg';
import './mvLoader.css';

/**
 * The site's one loading screen: the brass M, and under it a gold running
 * stitch that sews itself across, needle first.
 *
 *   <MvLoader message="Opening secure payment" />          full screen, blocks the page
 *   <MvLoader steps={['Saving…', 'Adding to bag']} />      walks through the steps
 *   <MvLoader variant="page" />                             in the page, for route loading;
 *                                                            shows only if loading takes a moment
 */
export default function MvLoader({ message = 'One moment', steps, kicker, note, variant = 'overlay' }) {
    const list = Array.isArray(steps) && steps.length ? steps : [message];
    const [at, setAt] = useState(0);
    const key = list.join('|');

    useEffect(() => {
        setAt(0);
        if (list.length < 2) return undefined;
        const t = setInterval(() => setAt((i) => Math.min(i + 1, list.length - 1)), 1600);
        return () => clearInterval(t);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key]);

    return (
        <div className={`mvl mvl--${variant}`} role="status" aria-live="polite">
            <div className="mvl__card">
                <span className="mvl__mark" style={{ '--mark': `url(${markImg})` }} aria-hidden="true"><i /></span>
                <span className="mvl__seam" aria-hidden="true">
                    <span className="mvl__stitch" />
                    <span className="mvl__needle" />
                </span>
                {kicker && <p className="mvl__kicker">{kicker}</p>}
                <p className="mvl__now" key={list[at]}>{list[at]}</p>
                {list.length > 1 && (
                    <ol className="mvl__steps">
                        {list.map((s, i) => (
                            <li key={s} className={i < at ? 'is-done' : i === at ? 'is-now' : ''} />
                        ))}
                    </ol>
                )}
                {note && <p className="mvl__note">{note}</p>}
            </div>
        </div>
    );
}
